export default "__VITE_ASSET__37d690d7__"